module.exports = __webpack_public_path__ + "media/src/images/top_covers/May_02-c5e0eedfc0aafffe3ccec403bf7f2537.png";